import { ExtraServiceChekoutScreen, ExtraServiceCheckoutEntityType } from 'constants/extra-service';
import { actions as extraServiceActions } from 'state/extra-service/slice';
import { transformPaymentAuthAction } from 'data/transformers/payment';
import { transformExtraServicePaymentDto } from 'data/transformers/extra-service-payment';
export function getExtraServiceOrderPaymentAuthAction(_ref) {
  let {
    extra_service_payment,
    authentication_action
  } = _ref;
  const extraServicePayment = transformExtraServicePaymentDto(extra_service_payment);

  if (authentication_action) {
    const paymentAuthAction = transformPaymentAuthAction(authentication_action);
    return extraServiceActions.triggerEmbeddedPaymentAuth({
      paymentId: extraServicePayment.id,
      authAction: paymentAuthAction
    });
  }

  if (extraServicePayment.payInRedirectUrl) {
    return extraServiceActions.triggerPaymentAuthWithRedirect({
      payInRedirectUrl: extraServicePayment.payInRedirectUrl
    });
  }

  return null;
}
export const getExtraServiceRedirectEntityType = page => {
  switch (page) {
    case ExtraServiceChekoutScreen.Balance:
      return ExtraServiceCheckoutEntityType.DirectDonationOrder;

    case ExtraServiceChekoutScreen.Donate:
      return ExtraServiceCheckoutEntityType.WebviewDirectDonationOrder;

    case ExtraServiceChekoutScreen.MessageList:
    case ExtraServiceChekoutScreen.ViewIssueDetails:
      return ExtraServiceCheckoutEntityType.MsgThreadReturnLabelOrder;

    default:
      return ExtraServiceCheckoutEntityType.Unknown;
  }
};